import React, { useEffect, useState } from 'react';
import "./RoomChange.css";
import Header from '../../components/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from "axios"
import useAuth from '../../../customHooks/useAuth';
import {toast} from "react-toastify"
import { baseUrl } from '../../../common/baseUrl';
import PageLoader from '../../components/PageLoader/PageLoader';
import axiosInstance from '../../../axiosInstance/axiosInstance';
import { getCurrentUser } from '../../../common/currentUser';
import Dropdown from "../../components/Dropdown/Dropdown";


export default function RoomChange() {

    const location = useLocation();
    const navigate = useNavigate();

    // Refresh Handle
    useAuth();

    const bookedRooms = location.state?.bookedRooms || [];
    const userId = localStorage.getItem("user_id");

    const hotelId = location.state?.hotelId || "";
    const bookingId = location.state?.bookingId || "";
    const hotelAddress = location.state?.hotelAddress || "";
    const hotelName = location.state?.hotelName || '';
    const checkInDate = location.state?.checkInDate || "";
    const checkOutDate = location.state?.checkOutDate || "";
    const status = location.state?.status || "";
    const activeTab = location.state?.activeTab || "";
    const booking_code = location.state?.booking_code || "";

    const [formData,setFormData] = useState({
        reason : "",
        specification : "",
        room : ""
    });

    // Loader
    const [isLoading,setIsLoading] = useState(false);

    // Check Data 
    useEffect(()=>{
        const checkId = ()=>{
            if(hotelId==="" || bookingId===""){
                navigate("/bookings");
            }
        }
        checkId();
    },[hotelId,bookingId,navigate]);

    const [errors, setErrors] = useState({});

    // Validation logic for individual fields
    const validateField = (field, value) => {
        const newErrors = { ...errors };

        switch (field) {
            case "reason":
                if (!value.trim()) {
                    newErrors.reason = "Reason is required";
                } else {
                    newErrors.reason = "";
                }
                break;
            // case "specification":
            //     if (!value.trim()) {
            //         newErrors.specification = "Specification or comment is required";
            //     } else {
            //         newErrors.specification = "";
            //     }
            //     break;
            case "room":
                if (!value.trim()) {
                    newErrors.room = "Room selection is required";
                } else {
                    newErrors.room = "";
                }
                break;
            default:
                break;
        }

        setErrors(newErrors);
    };

    // Form-level validation
    const validateForm = () => {
        const newErrors = {};
        if (!formData.reason.trim()) {
            newErrors.reason = "Reason is required";
        }
        // if (!formData.specification.trim()) {
        //     newErrors.specification = "Specification or comment is required";
        // }
        if (!formData.room.trim()) {
            newErrors.room = "Room selection is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Return true if no errors
    };


    // Handle Change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        validateField(name, value); // Validate on change
    };

  
    // Submit Handler
    const handleSubmit = async()=>{
        try{
            // Check if form is valid
            if (!validateForm()) {
                // console.log("Form has validation errors.");
                return;
            }
            setIsLoading(true);
            // console.log("Form Data : ",formData);
            const roomData = bookedRooms.find(item=>item.id===formData.room);
            // console.log("Room Number : ",roomData.room_number);
            const passData = {
                service_room : roomData.room_number,
                reason : formData.reason,
                room_specification : formData.specification,
            }
            // console.log("Pass Data : ",passData)


            const currentUser = await getCurrentUser();
 
            function findMatchedRooms(bookedRooms, usersData) {
                const contact = usersData.contact;
                const matchedRooms = bookedRooms.filter((room)=>{
                    // Check if guests are null or an empty array, and skip the room if true
                    if (!room.guests || room.guests.length === 0) {
                        return false; // Skip this room
                    }
                    const matchedGuest = room.guests.find((guest)=>guest.contact===contact);
                    if(matchedGuest) {
                        return true; //
                    }
                    else{
                        return false;
                    }
                });
                return matchedRooms;
            }        

            const usersData = currentUser;  
            const matchedRooms = findMatchedRooms(bookedRooms, usersData);

            if(matchedRooms.length<=0){
                // console.log("Booking is not Present ");
                return;
            }
            // console.log("MAtched Rooms : " + matchedRooms[0].id);




            try{
                const response = await axiosInstance.post(`/api/v1/users/${userId}/bookings/${bookingId}/booked-rooms/${matchedRooms[0].id}/guest-requests/post-checkin/room-change-request/`,passData);
                // console.log("Response for the Room Change : ",response);

                toast.success("Room Change Request Created Successfully");
                navigate("/bookings",{state : {activeRequests : "requests"}});

            }catch(error){
                toast.error(error?.response?.data?.message || "Some Error Occured");
                console.log(error);
            }
        }catch(error){
            console.log(error);
        }
        finally{
            setIsLoading(false);
        }
    }


  return (
    <>
        {
            isLoading && <PageLoader/>
        }
        <div className='roomChange'>
            <Header title="Change Room"
                hotelName = {hotelName}
                hotelAddress = {hotelAddress}
                checkInDate = {checkInDate}
                checkOutDate = {checkOutDate}
                status = {status}
                activeTab = {activeTab}
                hotelId = {hotelId}
                bookingId = {bookingId}
                movetoHotel = "movetoHotel" 
                booking_code = {booking_code}
            />
            {/* Room Change FIelds */}
            <div className='roomChange-data'>
                
                {/* Reason */}
                <div className='roomChange-fields'>
                    <div className='roomChange-name'>
                        <h4>Reason</h4>
                    </div>
                    <div className='roomChange-inp'>
                        <textarea name="reason" rows='4' cols="10" value={formData.reason} onChange={handleChange}></textarea>
                        {errors.reason && <p className="error-message">{errors.reason}</p>}
                    </div>
                </div>

                {/* Room specification & Additional comments */}
                <div className='roomChange-fields'>
                    <div className='roomChange-name'>
                        <h4>Room specification & Additional comments</h4>
                    </div>
                    <div className='roomChange-inp'>
                        <textarea name="specification" rows='4' cols="10" onChange={handleChange} value={formData.specification} ></textarea>
                        {errors.specification && <p className="error-message">{errors.specification}</p>}
                    </div>
                </div>

                {/* Button and Select Room */}
                <div className='roomChange-fields'>
                    <div className='roomChange-inpguests'>
                        <div className='roomChangeSelect'>
                            <Dropdown
                                name="room"
                                value={formData.room}
                                onChange={handleChange}
                                placeholder="Select a room"
                                options={bookedRooms
                                    .filter(room => room.room_number)
                                    .map(room => ({ value: room.id, label: String(room.room_number) }))}
                            />
                            {errors.room && <p className="error-message">{errors.room}</p>}
                        </div>
                        <div className='roomChange-btn'>
                            <button onClick={handleSubmit} disabled={ formData.room===""} >Send Request</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}
